import { useEffect } from "react";
import Button from "components/Button";
import CustomersTable from "../CustomerSelector/CustomersTable";
import useCustomerSelection from "../../hooks/useCustomerSelection";
import styles from "../ContactSelectionPanel/ContactSelectionPanel.module.scss";

const CustomerSelectionPanel = ({
  initialSelectedCustomers = [],
  onSelectionChange,
  className,
  sourceIds = [],
}) => {
  const {
    searchQuery,
    setSearchQuery,
    selectedSearchQuery,
    setSelectedSearchQuery,
    selectedCustomerIds,
    allCustomers,
    selectedCustomersData,
    selectedCustomersLoading,
    selectedCustomersHasMore,
    availableCustomersCount,
    customersLoading,
    customersError,
    hasMore,
    handleLoadMore,
    handleLoadMoreSelected,
    handleCustomerToggle,
    handleSelectAllVisible,
    handleRemoveCustomer,
    // Sort state & handlers
    sortDirection,
    handleSortClick,
    selectedSortDirection,
    handleSelectedSortClick,
  } = useCustomerSelection(initialSelectedCustomers, { sourceIds });

  // Notify parent component when selection changes
  useEffect(() => {
    if (onSelectionChange) {
      onSelectionChange(Array.from(selectedCustomerIds));
    }
  }, [selectedCustomerIds, onSelectionChange]);

  const availableCustomers = allCustomers.filter(
    (customer) => customer.id !== null && customer.id !== undefined,
  );

  return (
    <div className={`${styles.contactSelectionPanel} ${className || ""}`}>
      <div className={styles.mainContent}>
        {/* Available Customers Panel */}
        <div className={styles.availablePanel}>
          <CustomersTable
            title="Available Customers"
            searchQuery={searchQuery}
            onSearchChange={(e) => setSearchQuery(e.target.value)}
            showSearch={true}
            customers={availableCustomers}
            selectedCustomerIds={selectedCustomerIds}
            onCustomerToggle={handleCustomerToggle}
            customersLoading={customersLoading}
            customersError={customersError}
            hasMore={hasMore}
            onLoadMore={handleLoadMore}
            sortDirection={sortDirection}
            onSortClick={handleSortClick}
            headerActions={
              <div className={styles.headerActions}>
                <Button
                  type="button"
                  size="small"
                  style="secondary"
                  onClick={handleSelectAllVisible}
                  className={styles.addButton}
                  disabled={availableCustomersCount === 0}
                >
                  {`Add All (${availableCustomersCount})`}
                </Button>
              </div>
            }
            emptyStateMessage="No customers available"
            className={styles.tablePanel}
          />
        </div>

        {/* Selected Customers Panel */}
        <div className={styles.selectedPanel}>
          <CustomersTable
            title={`Selected Customers (${selectedCustomerIds.size})`}
            showSearch={true}
            searchQuery={selectedSearchQuery}
            onSearchChange={(e) => setSelectedSearchQuery(e.target.value)}
            customers={selectedCustomersData}
            selectedCustomerIds={selectedCustomerIds}
            onCustomerRemove={handleRemoveCustomer}
            customersLoading={selectedCustomersLoading}
            hasMore={selectedCustomersHasMore}
            onLoadMore={handleLoadMoreSelected}
            sortDirection={selectedSortDirection}
            onSortClick={handleSelectedSortClick}
            emptyStateMessage="No customers selected"
            isSelectedCustomersMode={true}
            className={styles.tablePanel}
          />
        </div>
      </div>
    </div>
  );
};

export default CustomerSelectionPanel;
